import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta';

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '',
    component: () => import('../views/Application'),
    children: [
      {
        path: '/',
        name: 'step-comune',
        component: () => import('@/views/steps/StepComune'),
      },
      {
        path: '/sei-cliente',
        name: 'step-sei-cliente',
        component: () => import('@/views/steps/StepSeiCliente'),
      },

      // Sì
      {
        path: '/cliente',
        name: 'step-si-cliente',
        component: () => import('@/views/steps/Si/StepCliente'),
      },
      {
        path: '/fornitura',
        name: 'step-si-fornitura',
        component: () => import('@/views/steps/Si/StepFornitura'),
      },
      {
        path: '/consumo',
        name: 'step-si-consumo',
        component: () => import('@/views/steps/Si/StepConsumo'),
      },
      {
        path: '/la-tua-rata',
        name: 'step-si-rata',
        component: () => import('@/views/steps/Si/StepRata'),
      },

      // No
      {
        path: '/tipo-di-fornitura',
        name: 'step-no-tipo-fornitura',
        component: () => import('@/views/steps/No/StepTipoFornitura'),
      },
      {
        path: '/i-tuoi-consumi',
        name: 'step-no-consumi',
        component: () => import('@/views/steps/No/StepConsumi'),
      },
      {
        path: '/non-conosco-i-miei-consumi/step/:steps',
        name: 'step-no-non-conosco-i-miei-consumi',
        props:true,
        component: () => import('@/views/steps/No/StepWizard'),
      },
      {
        path: '/potenza-contatore/:wizard',
        name: 'step-no-potenza-contatore',
        props:true,
        component: () => import('@/views/steps/No/StepPotenzaContatore'),
      },
      {
        path: '/la-tua-stima',
        name: 'step-no-stima',
        component: () => import('@/views/steps/No/StepStima'),
      },


      // Generale
      {
        path: '/attiva-offerta/:utilityType',
        name: 'attiva-offerta',
        props:true,
        component: () => import('@/views/steps/Forms/AttivaOfferta'),
      },
      {
        path: '/invia-stima/:utilityType',
        name: 'invia-stima',
        props:true,
        component: () => import('@/views/steps/Forms/InviaStima'),
      },
    ]
  },
  {
    path: '/email-sent/:type?',
    name: 'message-sent',
    props:true,
    component: () => import('../views/MessageSent.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    // return desired position
    if (to.hash) {
      return {
        selector: to.hash
      };
    }

    document.getElementById('appscroll').scrollTop = 0;

    return { x: 0, y: 0 }
  }
});

router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('config', 'G-2RG3Q9LVWL', {
      page_path: to.fullPath,
      page_title: to.name || document.title,
    });
  }
});

export default router
